import styled from 'styled-components'

const AddBonusStyles = styled.section`
  height: 80vh;
  overflow-y: scroll;
`;

export default AddBonusStyles;